export interface ScreenshotColorCategory {
  id: number
  name: string
}

export const SCREENSHOT_CASH_CATEGORY_COLOR = "#DED9C3"

export const SCREENSHOT_CATEGORY_COLORS = [
  "#17375E",
  "#52A3E4",
  "#C7D9F1",
  "#F5A7A7",
  "#FADBD8",
  "#3F8E78",
  "#4BBC9E",
  "#464759",
  "#6A6C85",
  "#C5CED8",
] as const

export function isCashCategory(
  categoryName: string | null | undefined,
): boolean {
  return categoryName?.trim().toLowerCase() === "cash"
}

export function buildScreenshotCategoryColorById(
  categories: ScreenshotColorCategory[],
): Map<number, string> {
  const colorById = new Map<number, string>()
  let colorIndex = 0

  categories.forEach((category) => {
    if (isCashCategory(category.name)) {
      colorById.set(category.id, SCREENSHOT_CASH_CATEGORY_COLOR)
      return
    }

    const color =
      SCREENSHOT_CATEGORY_COLORS[colorIndex % SCREENSHOT_CATEGORY_COLORS.length]
    colorById.set(category.id, color)
    colorIndex += 1
  })

  return colorById
}
